// GlobalAmbient: non-interactive, always-on targeting for ambient/weather effects.
// Behavior:
//  - Sets a global "input disabled" flag so other subsystems can skip pointer work.
//  - Forces Infinite mode once and pings the runtime to (re)start.
//  - Hides/unlocks overlay.
//  - No drawing, no input.

export default function installGlobalAmbient(env) {
  const WIN = typeof window !== "undefined" ? window : null;

  const UI_FIRE_MODE = "EmitterTool:UI:fireMode";
  const AMBIENT_LOCK = "EmitterTool:UI:ambientLock";

  // Set a global hint: any module can cheaply bail from pointer/overlay work.
  try { WIN.__ET_INPUT_DISABLED = true; } catch {}

  // Also persist an "ambient lock" so runtimes can refuse to restart/clear while ambient runs.
  try { localStorage.setItem(AMBIENT_LOCK, "1"); } catch {}

  // Flip to infinite (once) and notify runtime.
  try { localStorage.setItem(UI_FIRE_MODE, "infinite"); } catch {}
  try { WIN?.dispatchEvent(new CustomEvent("EmitterTool:InfiniteStart")); } catch {}

  // Hide overlay / unlock center.
  try {
    WIN?.dispatchEvent(new CustomEvent("EmitterTool:UI:EmitterOverlayConfig", {
      detail: { show: false, settings: { lockCenterOn: false } }
    }));
  } catch {}

  return {
    destroy() {
      // Clear the hint & ambient lock on teardown
      try { if (WIN && WIN.__ET_INPUT_DISABLED) delete WIN.__ET_INPUT_DISABLED; } catch {}
      try { localStorage.removeItem(AMBIENT_LOCK); } catch {}
    },
    draw() {},
    pickStart() {},
    onPointerMove() {},
    onPointerEnter() {},
    onPointerLeave() {},
    onClick() {},
  };
}
